import { useRef, useCallback, useEffect } from 'react';

/**
 * Hook customizado que fornece uma função de debounce
 * @returns {Object} Objeto contendo a função withDebounce
 */
const useDebounce = () => {
  const timeoutRef = useRef(null);

  // Limpa o timeout ao desmontar
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  /**
   * Cria uma versão debounced da callback fornecida
   * @param {Function} callback - A função a ser debounced
   * @param {number} delay - Delay em milissegundos
   * @returns {Function} Função debounced
   */
  const withDebounce = useCallback((callback, delay = 300) => {
    return (...args) => {
      // Garante que a callback é uma função antes de usá-la
      if (typeof callback !== 'function') {
        console.error('withDebounce espera uma função como primeiro argumento');
        return;
      }

      // Limpa o timeout anterior
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      // Define um novo timeout
      timeoutRef.current = setTimeout(() => {
        // Verifica se os argumentos existem e são válidos antes de passar para a callback
        callback(...args);
        timeoutRef.current = null;
      }, delay);
    };
  }, []);

  return { withDebounce };
};

export { useDebounce };
